module.exports = __webpack_public_path__ + "static/media/vinglabs_hermes_air_sorter2.eff2b7b5.jpg";